<template>
    <div class="full" id="home" :class="navHidden?'fullmove':'fullBack'">
        <!-- 侧边栏 -->
        <div id="sidebar" class="full">
            <!-- 标题 -->
            <router-link to="" class="logo">
                <img :src="menuLogoOther.navigationlogo&&!noLogo?menuLogoOther.navigationlogo:require('@/assets/img/login/logo_Upage.png')" alt v-if="!ifGree&!navHidden" :class="menuLogoOther.navigationlogo&&!noLogo?'nopaddingImg':'paddingImg'">
                <img :src="menuLogoOther.zoomlogo&&!noLogo?menuLogoOther.zoomlogo:require('@/assets/img/login/logo_Upage.png')" alt v-if="!ifGree&navHidden" :class="menuLogoOther.zoomlogo&&!noLogo?'nopaddingImg2':'paddingImg'">
                <img :src='menuLogo.navigationlogo' alt v-if="ifGree&!navHidden" class="nopaddingImg">
                <img :src='menuLogo.zoomlogo' alt v-if="ifGree&navHidden" class="nopaddingImg2">
            </router-link>
            <!-- 菜单 -->
            <partMenu :menus="menulist" :activeMenu="activeMenu"/>
        </div>
        <!-- 页面主体 -->
        <div id="con"   class="full"
        >
            <headerNav @changeNav="changeNav"></headerNav>
            <keep-alive>
                <router-view v-if="$route.meta.keepAlive"></router-view>
            </keep-alive>
            <router-view v-if="!$route.meta.keepAlive"></router-view>
            <div class="footerJS">Copyright© 2019  杭州久点网络技术有限公司</div>
        </div>
    </div>
</template>
<script>
    import partMenu from "../common/menu/index";
    import headerNav from "../common/menu/headerNav";
    import { mapGetters ,mapState,mapActions} from 'vuex';
    // import { getRouter } from "@/bridge/var";
    export default {
        components: { partMenu , headerNav},
        data() {
            return {
                menus: [],
                activeMenu: {
                    fullPath: ""
                },
                ifGree:false,//是否是格力
                noLogo:false,//是否是内部
            };
        },
        computed: {
            ...mapGetters(["menulist","menuLogo"]),
            ...mapState({
                navHidden: state => state.menu.navHidden,
                menuLogoOther:state => state.menu.menuLogoOther
            }),
        },
        mounted() {
            // window.addEventListener('scroll', this.handleScroll)
            if(window.location.href.indexOf('console')!==-1||window.location.href.indexOf('localhost')!==-1||window.location.href.indexOf('192.168')!==-1){
                 this.noLogo=true
            }else{
                this.noLogo=false
            }
            this.selecthcmloginlogo()
            let url=window.location.href
            if(url.indexOf('gree')!=-1) this.ifGree=true
            else  this.ifGree=false
        },
        created(){
          console.log(screen.width)
            if (screen.width < 1366) {
                this.$store.commit('changeHidenMenu',false)
            }
            this.selecthcmlogo()
            // getRouter().then(result => {
            //     this.$router.options.routes = result.router;
            //     this.$router.addRoutes(result.router);
            //     this.$store.commit('setRouter', result);
            // })
        },
        methods: {
            ...mapActions(["selecthcmloginlogo",'selecthcmlogo']),
            changeNav(){
                this.$store.commit('changeHidenMenu')
            },
            handleScroll(){
                var nWidth=document.documentElement.scrollLeft||document.body.scrollLeft;
                //获取div标签对象
                let breadcrumb=document.getElementsByClassName('el-breadcrumb')
                let headerNav=document.getElementsByClassName('headerNav')
                if(breadcrumb||headerNav){
                    if(breadcrumb&breadcrumb!=undefined) breadcrumb[0].style.left =184-nWidth+'px';
                    if(headerNav&headerNav!=undefined)  headerNav[0].style.left =184-nWidth+'px';
                }
            },
        },

    };
</script>

<style lang="scss">
    @import "../common/style/var";
    #home {
        $sider-w: 184px;
        .el-breadcrumb__item:last-child .el-breadcrumb__inner{
            color:#333;
        }
        .nopaddingImg2{
            width: 60px!important;
            height: 100%!important;
        }
        .nopaddingImg{
            padding: 0;
            width:100%!important;
            height:100%!important;
        }
        .paddingImg{
            margin: 10px 16px;
        }
        .el-breadcrumb__inner{
            color:#999;
            font-size: 12px;
        }
        // 菜单栏
        #sidebar {
            position: fixed;
            right: auto;
            width: $sider-w;
            background: #19233c;
            display: flex;
            flex-direction: column;
			transition: transform 0.2s;
			z-index: 10;
            // logo
            .logo {
                display: block;
                text-align: center;
                font-size: 15px;
                color: $sider-font;
                height: 50px;
                box-sizing: border-box;
                background: #0e1626;
                img {
                    display: inline-block;
                    width: 121px;
                    height: 26px;
                }
            }
        }
        // 页面内容
        #con {
            background: $con-bg;
            left: $sider-w;
            height: 100%;
        }
    }
    .fullBack{
        #sidebar{
            animation:mymovewidth2 0.3s;
            animation-fill-mode: forwards;
        }
        #con{
            animation:mymoveleft2 0.3s;
            animation-fill-mode: forwards;
        }
         #headerNav{
            animation-name:mymoveleft2,mymovewidth2_header;
            animation-duration:0.3s, 0.3s;
            animation-fill-mode: forwards;
        }
        .el-breadcrumb{
            animation-duration:0s, 0s;
        }
    }
    .fullmove{
            #sidebar{
                animation:mymovewidth 0.3s;
                animation-fill-mode: forwards;
            }
            #con{
                animation:mymoveleft 0.3s;
                animation-fill-mode: forwards;
            }
            #headerNav,.el-breadcrumb{
                animation-name:mymoveleft,mymovewidth1_header;
                animation-duration:0.3s, 0.3s;
                animation-fill-mode: forwards;
            }
        }
        @keyframes mymovewidth
        {
            from {width:184px;}
            to {width:60px;}
        }
        @keyframes mymoveleft
        {
            from {left:184px;}
            to {left:60px;}
        }
        @keyframes mymovewidth1_header
        {
            from {width: calc(100% - 184px);}
            to {width: calc(100% - 60px);}
        }
        // 返回
        @keyframes mymovewidth2
        {
            from {width:60px;}
            to {width:184px;}
        }
        @keyframes mymoveleft2
        {
            from {left:60px;}
            to {left:184px;}
        }
        @keyframes mymovewidth2_header
        {
            from {width: calc(100% - 60px);}
            to {width: calc(100% - 184px);}
        }
</style>
